'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta(label, to) {
  this.gz = null;
  this.gA = null;
  this.gz = label;
  this.gA = to;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta as $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta as $h_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta };
$h_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-340977865), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta)) {
    if ((this.gz === x$0.gz)) {
      var x = this.gA;
      var x$2 = x$0.gA;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "SecondaryCta";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.gz;
  }
  if ((n === 1)) {
    return this.gA;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bG)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta };
var $d_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta, "io.intela.sites.digitalinternship.data.Segments$SecondaryCta", ({
  bG: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta as $d_Lio_intela_sites_digitalinternship_data_Segments$SecondaryCta };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Secondary-Cta.js.map
